import clsx from 'clsx';
import { Table as BTable } from 'react-bootstrap';
import './style.scss';
type Props = React.ComponentProps<typeof BTable>;

const Table = (props: Props) => {
  return <BTable {...props} className={clsx(props.className, 'wyz-table')} />;
};

export default Table;
